import { winnersOf } from './standings';
import { byDateDesc } from './format';

/** ['Ago','Pero','Bimbo'] -> 'Ago, Pero i Bimbo' */
export const joinNames = (names = []) => {
  const list = names.filter(Boolean);
  if (list.length <= 1) return list[0] || '';
  return `${list.slice(0, -1).join(', ')} i ${list[list.length - 1]}`;
};

const cardLine = (m) => {
  const games = (m.games || []).map((g) => `${g.name.toLowerCase()} ${g.a}:${g.b}`).join(', ');
  const w = joinNames(winnersOf(m, 'karte'));
  return `${joinNames(m.teamA)} / ${joinNames(m.teamB)} — ${games}${w ? ` → ${w}` : ''}`;
};

const bocceLine = (m) => {
  const w = joinNames(winnersOf(m, 'boce'));
  const note = m.note ? ` (${m.note})` : '';
  return `${joinNames(m.teamA)} / ${joinNames(m.teamB)} — ${m.scoreA}:${m.scoreB}${note}${w ? ` → ${w}` : ''}`;
};

/**
 * Match days that have results but no zapisnik yet, newest first.
 */
export const daysWithoutReport = (karte = [], boce = [], reports = []) => {
  const covered = new Set(reports.map((r) => r.date));
  const days = new Set([...karte, ...boce].map((m) => m.date).filter(Boolean));
  return [...days]
    .filter((d) => !covered.has(d))
    .sort((a, b) => byDateDesc({ date: a }, { date: b }))
    .map((date) => ({
      date,
      karte: karte.filter((m) => m.date === date).length,
      boce: boce.filter((m) => m.date === date).length,
    }));
};

/**
 * Scaffold for a new report: the day's results written out as plain lines,
 * so there's something concrete to rewrite into prose rather than a blank box.
 */
export const draftReportFor = (date, karte = [], boce = []) => {
  const k = karte.filter((m) => m.date === date);
  const b = boce.filter((m) => m.date === date);
  const paragraphs = [];

  if (k.length) {
    paragraphs.push(`KARTE (${k.length}): ${k.map(cardLine).join(' • ')}`);
  }
  if (b.length) {
    paragraphs.push(`BOĆE (${b.length}): ${b.map(bocceLine).join(' • ')}`);
  }
  if (!paragraphs.length) paragraphs.push('');

  return { date, title: '', intro: '', paragraphs };
};
